module.exports = __webpack_public_path__ + "img/9b4b4cf.png";